/**
 * Blog yazılarının ortak yazar bilgisi.
 * Kurum markası önceliği: Author = Riskmatik (Organization). Kişisel imza yok.
 *
 * Tarihçe: önceden Person + name vardı; "kurumsal görünüm" tercihi ile
 * Organization-only yapıya geçildi (2026-05-02).
 */

// Shared blog author info (organization branding, no personal signature)
export interface BlogAuthor {
  name: string;
  jobTitle: string;
  initials: string;
  url: string;
}

export const BLOG_AUTHOR: BlogAuthor = {
  name: 'Riskmatik',
  jobTitle: 'İSG Yazılım Platformu',
  initials: 'R',
  url: 'https://www.riskmatik.com'
};

/**
 * Schema.org Article author alanı için Organization nesnesi.
 * Hem author hem publisher = Riskmatik (kurum imzası).
 */
export function authorPersonSchema() {
  return {
    '@type': 'Organization',
    name: BLOG_AUTHOR.name,
    url: BLOG_AUTHOR.url,
    description: 'Türkiye\'de İSG yönetim platformu — 33 modül, ISO 45001 + 6331 uyumlu.',
    knowsAbout: [
      'Risk Değerlendirmesi Metodolojileri (Fine-Kinney, 5×5 Matris)',
      'İSG Mevzuatı ve 6331 Sayılı Kanun Uygulamaları',
      'ISO 45001 İSG Yönetim Sistemleri',
      'Dijital İSG Yönetim Sistemleri ve Otomasyon'
    ]
  };
}

/**
 * UI imzası için kısa string (yazı altında, küçük punto).
 */
export function authorBylineText() {
  return `${BLOG_AUTHOR.name} — ${BLOG_AUTHOR.jobTitle}`;
}
